export default (ms: number): Promise<void> =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });



// WEBPACK FOOTER //
// ./src/utils/delay.ts